export default __webpack_public_path__ + "static/media/82.c0396f10.png";